import { connect } from "react-redux";
import EntitieComponent from "../../Components/Entities/EntitieComponent";
import { setScopes, setScopesNames, setRoles, setAllRoles } from "../../Redux/Actions/ScopesActions";

const mapStateToProps = (state) => ({
  SCOPES: state.reducer.SCOPES,
  ACTIVE_TENANT: state.reducer.ACTIVE_TENANT,
  ALL_ROLES: state.reducer.ALL_ROLES,
});

const mapDispatchToProps = (dispatch) => ({
  setScopes: (scopes) => dispatch(setScopes(scopes)),
  setScopesNames: (names) => dispatch(setScopesNames(names)),
  setRoles: (roles) => dispatch(setRoles(roles)),
  setAllRoles: (roles) => dispatch(setAllRoles(roles)),
});
 
export default connect(mapStateToProps, mapDispatchToProps)(EntitieComponent);